export const assetClassValues = [
    "EXTERNAL_BANK_ACCOUNT",
    "FIXED_INCOME_FUND",
    "FX",
    "SAVINGS",
    "TERM_DEPOSIT",
];
const accountTypeValues = [
    "FIXED_INCOME_FUND",
    "FX",
    "SAVINGS",
    "TERM_DEPOSIT",
    "TRANSACTION",
];
export const currencyValues = [
    "AUD",
    "CAD",
    "CNY",
    "EUR",
    "GBP",
    "HKD",
    "JPY",
    "NZD",
    "SGD",
    "USD",
    "MYR",
    "BRL",
    "CHF",
    "PHP",
    "SEK",
    "ZAR",
];
